import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=03e98618&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=03e98618&prod&scoped=true&lang=css"
import style1 from "./ChatBox.vue?vue&type=style&index=1&id=03e98618&prod&scoped=true&lang=css"
import style2 from "./ChatBox.vue?vue&type=style&index=2&id=03e98618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e98618",
  null
  
)

export default component.exports